'use strict';

angular.module('internal.education', ['ngAnimate', 'ui.bootstrap'])
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            // Courses tab
            .state('internal.education.courses', {
                url: '/education/courses',
                templateUrl: paths.app + 'education/components/courses/courses.html',
                controller: 'InternalEducationCourses',
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('internal.education.denied');
                            }
                        });
                    }]
                }
            })

            // URL AND STATE ONLY CHANGE
            .state("internal.education.course", {
                abstract: true,
                templateUrl: paths.app + "education/layouts/courses.html",
                controller: "InternalEducationCourseDetails",
                params: {
                    id: 'create'
                }
            })
            .state("internal.education.course.details", {
                abstract: true,
                templateUrl: paths.app + "education/layouts/gutter.html",
                controller: "InternalEducationCourseDetails",
                params: {
                    id: 'create'
                }
            })
            .state("internal.education.course.details.details", {
                url: '/education/courses/:id',
                templateUrl: paths.app + 'education/components/course-details/course-details.html',
                controller: "InternalEducationCourseDetails",
                params: {
                    id: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.course.details").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.course.details.subcourses", {
                url: '/education/courses/:id/subcourses',
                templateUrl: paths.app + 'education/components/course-details/course-details.html',
                controller: "InternalEducationCourseDetails",
                params: {
                    id: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.course.details").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.course.details.credithours", {
                url: '/education/courses/:id/credithours',
                templateUrl: paths.app + 'education/components/course-details/course-details.html',
                controller: "InternalEducationCourseDetails",
                params: {
                    id: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.course.details").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.course.details.prerequisites", {
                url: '/education/courses/:id/prerequisites',
                templateUrl: paths.app + 'education/components/course-details/course-details.html',
                controller: "InternalEducationCourseDetails",
                params: {
                    id: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.course.details").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.course.details.attendees", {
                url: '/education/courses/:id/attendees',
                templateUrl: paths.app + 'education/components/course-details/course-details.html',
                controller: "InternalEducationCourseDetails",
                params: {
                    id: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.course.details").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.course.details.documents", {
                url: '/education/courses/:id/documents',
                templateUrl: paths.app + 'education/components/course-details/course-details.html',
                controller: "InternalEducationCourseDetails",
                params: {
                    id: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.course.details").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.course.details.document", {
                url: '/education/courses/:id/document/:documentid',
                templateUrl: paths.app + 'education/components/course-details/course-details.html',
                controller: "InternalEducationCourseDetails",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.course.details").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.course.details.tests", {
                url: '/education/courses/:id/tests',
                templateUrl: paths.app + 'education/components/course-details/course-details.html',
                controller: "InternalEducationCourseDetails",
                params: {
                    id: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.course.details").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.course.details.test", {
                url: '/education/courses/:id/test/:testid',
                templateUrl: paths.app + 'education/components/course-details/course-details.html',
                controller: "InternalEducationCourseDetails",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.course.details").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.course.details.skillexams", {
                url: '/education/courses/:id/skillexams',
                templateUrl: paths.app + 'education/components/course-details/course-details.html',
                controller: "InternalEducationCourseDetails",
                params: {
                    id: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.course.details").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            //Course Charges
            .state("internal.education.course.charges", {
                url: '/education/courses/:id/charges',
                templateUrl: paths.app + 'education/components/course-details/course-details.html',
                controller: "InternalEducationCourseDetails",
                params: {
                    id: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.course.charges").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            //Course Correspondence List
            .state("internal.education.course.correspondence", {
                url: '/education/courses/:id/correspondence',
                templateUrl: paths.app + 'education/components/course-details/course-details.html',
                controller: "InternalEducationCourseDetails",
                params: {
                    id: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.course.correspondence").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            //Course Correspondence Send
            .state("internal.education.course.sendcorrespondence", {
                url: '/education/courses/:id/correspondence/send',
                templateUrl: paths.app + 'education/components/course-details/course-details.html',
                controller: "InternalEducationCourseDetails",
                params: {
                    id: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.course.correspondence").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            //Course Correspondence Display
            .state("internal.education.course.displaycorrespondence", {
                url: '/education/courses/:id/correspondence/:correspondenceId/display',
                templateUrl: paths.app + 'education/components/course-details/course-details.html',
                controller: "InternalEducationCourseDetails",
                params: {
                    id: null,
                    correspondenceId: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.course.correspondence").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            //Course History
            .state("internal.education.course.history", {
                url: '/education/courses/:id/history',
                templateUrl: paths.app + 'education/components/course-details/course-details.html',
                controller: "InternalEducationCourseDetails",
                params: {
                    id: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.course.history").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            // Course Notes List Page
            .state("internal.education.course.notes", {
                url: "/education/courses/:id/notes",
                templateUrl: paths.app + "education/components/course-notes/course-notes.html",
                controller: "InternalEducationNotes",
                params: {
                    id: null,
                },
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.education.course.notes").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            // Course Notes Page
            .state("internal.education.course.note", {
                url: "/education/courses/:id/note/:noteId",
                templateUrl: paths.app + "education/components/course-note/course-note.html",
                controller: "InternalEducationNote",
                params: {
                    id: null,
                    noteId: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.course.notes").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            // Configuration Tab
            .state("internal.education.configuration", {
                abstract: true,
                templateUrl: paths.app + "education/layouts/configuration.html"
            })
            .state("internal.education.configuration.topics", {
                url: "/education/topics",
                templateUrl: paths.app + "education/components/topics/topics.html",
                controller: "InternalEducationTopics",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.education.configuration.topics").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.topic", {
                url: "/education/topic/:id",
                templateUrl: paths.app + "education/components/topic/topic.html",
                controller: "InternalEducationTopic",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.topics").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.levels", {
                url: "/education/levels",
                templateUrl: paths.app + "education/components/levels/levels.html",
                controller: "InternalEducationLevels",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.education.configuration.levels").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.level", {
                url: "/education/level/:id",
                templateUrl: paths.app + "education/components/level/level.html",
                controller: "InternalEducationLevel",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.levels").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.courseattributes", {
                url: "/education/courseattributes",
                templateUrl: paths.app + "education/components/course-attributes/course-attributes.html",
                controller: "InternalEducationCourseAttributes",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.education.configuration.courseattributes").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.courseattribute", {
                url: "/education/courseattribute/:id",
                templateUrl: paths.app + "education/components/course-attribute/course-attribute.html",
                controller: "InternalEducationCourseAttribute",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.courseattributes").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.autonumbers", {
                url: "/education/autonumbers",
                templateUrl: paths.app + "education/components/auto-numbers/auto-numbers.html",
                controller: "InternalEducationAutoNumbers",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.education.configuration.autonumbers").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.autonumber", {
                url: "/education/autonumber/:id",
                templateUrl: paths.app + "education/components/auto-number/auto-number.html",
                controller: "InternalEducationAutoNumber",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.autonumbers").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.alerttypes", {
                url: "/education/alerttypes",
                templateUrl: paths.app + "education/components/alert-types/alert-types.html",
                controller: "InternalEducationAlertTypes",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.education.configuration.alerttypes").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.alerttype", {
                url: "/education/alerttype/:id",
                templateUrl: paths.app + "education/components/alert-type/alert-type.html",
                controller: "InternalEducationAlertType",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.alerttypes").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.mergetemplates", {
                url: "/education/mergetemplates",
                templateUrl: paths.app + "education/components/merge-templates/merge-templates.html",
                controller: "InternalEducationMergeTemplates",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.education.configuration.mergetemplates").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.mergetemplate", {
                abstract: true,
                templateUrl: paths.app + "education/layouts/gutter.html",
                controller: "InternalEducationMergeTemplate",
                params: {
                    id: 'create'
                }
            })
            .state("internal.education.configuration.mergetemplate.details", {
                url: "/education/mergetemplate/:id",
                templateUrl: paths.app + "education/components/merge-template/merge-template.html",
                controller: "InternalEducationMergeTemplate",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.mergetemplates").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.mergetemplate.permissions", {
                url: "/education/mergetemplate/:id/permissions",
                templateUrl: paths.app + "education/components/merge-template/merge-template.html",
                controller: "InternalEducationMergeTemplate",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.mergetemplates").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.coursenames", {
                url: "/education/coursenames",
                templateUrl: paths.app + "education/components/course-names/course-names.html",
                controller: "InternalEducationCourseNames",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.education.configuration.coursenames").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.coursename", {
                url: "/education/coursename/:id",
                templateUrl: paths.app + "education/components/course-name/course-name.html",
                controller: "InternalEducationCourseName",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.coursenames").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.coursestatuses", {
                url: "/education/coursestatuses",
                templateUrl: paths.app + "education/components/course-statuses/course-statuses.html",
                controller: "InternalEducationCourseStatuses",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.education.configuration.coursestatuses").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.coursestatus", {
                url: "/education/coursestatus/:id",
                templateUrl: paths.app + "education/components/course-status/course-status.html",
                controller: "InternalEducationCourseStatus",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.coursestatuses").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.attendeestatuses", {
                url: "/education/attendeestatuses",
                templateUrl: paths.app + "education/components/attendee-statuses/attendee-statuses.html",
                controller: "InternalEducationAttendeeStatuses",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.education.configuration.attendeestatuses").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.attendeestatus", {
                url: "/education/attendeestatus/:id",
                templateUrl: paths.app + "education/components/attendee-status/attendee-status.html",
                controller: "InternalEducationAttendeeStatus",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.attendeestatuses").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.pdfcertificates", {
                url: "/education/pdfcertificates",
                templateUrl: paths.app + "education/components/pdf-certificates/pdf-certificates.html",
                controller: "InternalEducationPdfCertificates",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.education.configuration.pdfcertificates").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.pdfcertificate", {
                url: "/education/pdfcertificate/:id",
                templateUrl: paths.app + "education/components/pdf-certificate/pdf-certificate.html",
                controller: "InternalEducationPdfCertificate",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.pdfcertificates").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.coursetypes", {
                url: "/education/coursetypes",
                templateUrl: paths.app + "education/components/course-types/course-types.html",
                controller: "InternalEducationCourseTypes",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.education.configuration.coursetypes").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.coursetype", {
                abstract: true,
                templateUrl: paths.app + "education/layouts/gutter.html",
                controller: "InternalEducationCourseType",
                params: {
                    id: 'create'
                }
            })
            .state("internal.education.configuration.coursetype.details", {
                url: "/education/coursetype/:id",
                templateUrl: paths.app + "education/components/course-type/course-type.html",
                controller: "InternalEducationCourseType",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.coursetypes").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.coursetype.display", {
                url: "/education/coursetype/:id/display",
                templateUrl: paths.app + "education/components/course-type/course-type.html",
                controller: "InternalEducationCourseType",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.coursetypes").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.coursetype.permissions", {
                url: "/education/coursetype/:id/permissions",
                templateUrl: paths.app + "education/components/course-type/course-type.html",
                controller: "InternalEducationCourseType",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.coursetypes").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.coursetype.restrictions", {
                url: "/education/coursetype/:id/restrictions",
                templateUrl: paths.app + "education/components/course-type/course-type.html",
                controller: "InternalEducationCourseType",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.coursetypes").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.coursetype.triggerworkflow", {
                url: "/education/coursetype/:id/triggerworkflow",
                templateUrl: paths.app + "education/components/course-type/course-type.html",
                controller: "InternalEducationCourseType",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.coursetypes").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.coursetype.triggerworkflowconfig", {
                url: "/education/coursetype/:id/triggerworkflowconfiguration",
                templateUrl: paths.app + "education/components/course-type/course-type.html",
                controller: "InternalEducationCourseType",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.coursetypes").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.scheduledtasks", {
                url: "/education/scheduledtasks",
                templateUrl: paths.app + "education/components/scheduled-tasks/scheduled-tasks.html",
                controller: "InternalEducationScheduledTasks",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.education.configuration.scheduledtasks").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.scheduledtask", {
                abstract: true,
                templateUrl: paths.app + "education/layouts/gutter.html",
                controller: "InternalEducationScheduledTask",
                params: {
                    id: 'create'
                }
            })
            .state("internal.education.configuration.scheduledtask.details", {
                url: "/education/scheduledtask/:id",
                templateUrl: paths.app + "education/components/scheduled-task/scheduled-task.html",
                controller: "InternalEducationScheduledTask",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.scheduledtasks").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.scheduledtask.logs", {
                url: "/education/scheduledtask/:id/log",
                templateUrl: paths.app + "education/components/scheduled-task/scheduled-task.html",
                controller: "InternalEducationScheduledTask",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.scheduledtasks").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.scheduledtask.logcourses", {
                url: "/education/scheduledtask/:id/log/:logid/courses",
                templateUrl: paths.app + "education/components/scheduled-task/scheduled-task.html",
                controller: "InternalEducationScheduledTask",
                params: {
                    id: 'create',
                    logid: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.scheduledtasks").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.scheduledtask.preview", {
                url: "/education/scheduledtask/:id/preview",
                templateUrl: paths.app + "education/components/scheduled-task/scheduled-task.html",
                controller: "InternalEducationScheduledTask",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.scheduledtasks").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.educationrules", {
                url: "/education/educationrules",
                templateUrl: paths.app + "education/components/education-rules/education-rules.html",
                controller: "InternalEducationRule",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.education.configuration.educationrules").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.educationrule", {
                abstract: true,
                templateUrl: paths.app + "education/layouts/gutter.html",
                controller: "InternalEducationRule",
                params: {
                    id: 'create'
                }
            })
            .state("internal.education.configuration.educationrule.details", {
                url: "/education/educationrule/:id",
                templateUrl: paths.app + "education/components/education-rules/education-rules.html",
                controller: "InternalEducationRule",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.educationrules").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.educationrule.criteria", {
                url: "/education/educationrule/:id/criteria",
                templateUrl: paths.app + "education/components/education-rules/education-rules.html",
                controller: "InternalEducationRule",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.educationrules").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.educationrule.preview", {
                url: "/education/educationrule/:id/preview",
                templateUrl: paths.app + "education/components/education-rules/education-rules.html",
                controller: "InternalEducationRule",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.educationrules").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.internalviews", {
                url: "/education/internalviews",
                templateUrl: paths.app + "education/components/internal-views/internal-views.html",
                controller: "InternalEducationInternalViews",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.education.configuration.internalviews").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.internalview", {
                abstract: true,
                templateUrl: paths.app + "education/layouts/gutter.html",
                controller: "InternalEducationInternalView",
                params: {
                    id: 'create'
                }
            })
            .state("internal.education.configuration.internalview.details", {
                url: "/education/internalview/:id",
                templateUrl: paths.app + "education/components/internal-view/internal-view.html",
                controller: "InternalEducationInternalView",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.internalviews").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.internalview.criteria", {
                url: "/education/internalview/:id/criteria",
                templateUrl: paths.app + "education/components/internal-view/internal-view.html",
                controller: "InternalEducationInternalView",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.internalviews").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.internalview.permissions", {
                url: "/education/internalview/:id/permission",
                templateUrl: paths.app + "education/components/internal-view/internal-view.html",
                controller: "InternalEducationInternalView",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.internalviews").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.internalview.preview", {
                url: "/education/internalview/:id/preview",
                templateUrl: paths.app + "education/components/internal-view/internal-view.html",
                controller: "InternalEducationInternalView",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.internalviews").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.publiclookup", {
                url: "/education/publiclookup",
                templateUrl: paths.app + "education/components/public-lookup/public-lookup.html",
                controller: "InternalEducationPublicLookup",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.education.configuration.publiclookup").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.regions", {
                url: "/education/regions",
                templateUrl: paths.app + "education/components/regions/regions.html",
                controller: "InternalEducationRegions",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.education.configuration.regions").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.region", {
                url: "/education/region/:id",
                templateUrl: paths.app + "education/components/region/region.html",
                controller: "InternalEducationRegion",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.regions").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.locations", {
                url: "/education/locations",
                templateUrl: paths.app + "education/components/locations/locations.html",
                controller: "InternalEducationLocations",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.education.configuration.locations").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.location", {
                abstract: true,
                templateUrl: paths.app + "education/layouts/gutter.html",
                controller: "InternalEducationLocation",
                params: {
                    id: 'create'
                }
            })
            .state("internal.education.configuration.location.details", {
                url: "/education/location/:id",
                templateUrl: paths.app + "education/components/location/location.html",
                controller: "InternalEducationLocation",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.locations").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.location.coordinator", {
                url: "/education/location/:id/coordinators",
                templateUrl: paths.app + "education/components/location/location.html",
                controller: "InternalEducationLocation",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.locations").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.location.instructor", {
                url: "/education/location/:id/instructors",
                templateUrl: paths.app + "education/components/location/location.html",
                controller: "InternalEducationLocation",
                params: {
                    id: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.education.configuration.locations").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.coordinators", {
                url: "/education/coordinators",
                templateUrl: paths.app + "education/components/coordinators/coordinators.html",
                controller: "InternalEducationCoordinators",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.education.configuration.coordinators").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.instructors", {
                url: "/education/instructors",
                templateUrl: paths.app + "education/components/instructors/instructors.html",
                controller: "InternalEducationInstructors",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.education.configuration.instructors").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
            .state('internalNH.preview', {
                url: '/education/preview/:previewUserId/:previewPageName',
                templateUrl: paths.app + 'education/components/preview/preview.html',
                controller: 'InternalEducationPreview',
                params: {
                    previewUserId: null,
                    previewPageName: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                //$state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state("internal.education.configuration.selfentered", {
                url: "/education/selfentered",
                templateUrl: paths.app + "education/components/self-entered/self-entered.html",
                controller: "InternalEducationSelfEntered",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.education.configuration.selfentered").then(function (access) {
                            if (!access) {
                                $state.go("internal.education.denied");
                            }
                        });
                    }]
                }
            })
    }])
    ;